<template>
  <b-modal
      id="membersListModal"
      :title="$t('project.dashboard.membersListModalTitle')"
      ok-only
      no-fade
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="secondary"
      header-text-variant="white"
      hide-header-close
      hide-backdropp>
    <div class="text-info" style="padding: 0 1rem  1rem 0; font-size: 1.2rem">
      {{projectName}}
    </div>

    <table class="table table-hover members-table">
      <tbody class="members-tbody">
      <tr v-for="(collaborator,index) in collaborators" :key="collaborator.id">
        <td>
          <div class="text-info font-weight-bold">{{ collaborator.displayName }}</div>
          <div class="text-muted small">{{ collaborator.email }}</div>
        </td>
        <td>
          <span class="badge badge-rounded badge-secondary p-2">{{(typeof collaborator.membership === "string") && ['OWNER', 'GUEST', 'MEMBER'].indexOf(collaborator.membership) >= 0 ?$t('project.settings.participants.roles.' + collaborator.membership.toLowerCase()) : collaborator.membership }}</span>
        </td>
        <td>
          <b-button
              v-if="collaborator.membership !== 'OWNER'"
              size="sm"
              variant="outline-danger"
              class="float-right pb-0"
              @click.stop="removeCollaborator(collaborator, index)"
              :title="$t('project.settings.participants.removeMember')">
            <icon name="trash"></icon>
          </b-button>
        </td>
      </tr>
      </tbody>
    </table>
  </b-modal>

</template>

<script>

import projectsApi from "../api/projects";
import toastr from "toastr";
import i18n from "../i18n.bootstrap";

export default {
    name: "members-list-modal",
    props: ["collaborators", "projectName", "projectId"],
    methods: {

      removeCollaborator(collaborator, index) {
        const { id: collaboratorId, displayName: collaboratorName } = collaborator;

        const removeCollaboratorAction = () => {
          return projectsApi.removeCollaboratorByAdmin(this.projectId, collaboratorId)
              .then((res) => {
                if(res) {
                  this.collaborators.splice(index, 1);
                  toastr.success(i18n.t('project.dashboard.successMemberDelete', {memberName: collaboratorName}));
                }
              })
              .catch(() => {
                toastr.error(i18n.t('project.dashboard.errorMemberDelete', {memberName: collaboratorName}));
              });
        };

        this.$snotify.confirm(i18n.t('general.promptQuestion'), '', {
          closeOnClick: true,
          backdrop: 0.3,
          buttons: [
            { text: i18n.t('general.yes'), action: removeCollaboratorAction },
            { text: i18n.t('general.no') }
          ]
        });

      },
    },

    computed: {
        projectPermissions() {
          if(this.$store.state.projects.currentProject.projectData.role){
            return this.$store.state.projects.currentProject.projectData.role.permissions;
          } else {
            return [];
          }
        },
    },
  }
</script>

<style scoped>

  .badge-rounded {

  }

  .members-table {
    display: block;
    max-height: 41vh;
    overflow-y:  auto;

  }

  .members-tbody {
    display: table;
    width: 100%;
  }
  .p-1 {
    padding: 0.25rem !important;
  }
</style>
